export default __webpack_public_path__ + "static/daniel-ehrenberg-525b9a69f9bba3b5e8aa5e978da3543f.jpg";